import {objectFromEntries} from '@benchling/js-utils';

import {AnalyticsParameterValue} from 'insights/parameters/__generated/AnalyticsParameterValue';
import {updateValueJsonForConfig} from 'insights/parameters/data/ParameterListOperations';
import {LegacyRunQueryOutput, Row} from 'insights/warehouse/AnalyticsWarehouseTypes';

import {AnalyticsParameterConfigGraphQL} from '../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';

export interface ExperimentalShapashTableOptions {
  onClick: (row: Row) => void;
}

/**
 * Update parameter values based on the values of the clicked row.
 *
 * Updates all parameters whose name matches one of the column headers of the data with the corresponding
 * value in the selected row.
 */
export default function handleClickShapashTableRow(
  row: Row,
  legacyRunQueryOutput: LegacyRunQueryOutput,
  parameterConfigs: Array<AnalyticsParameterConfigGraphQL>,
  oldParameterValues: Array<AnalyticsParameterValue>,
  updateParameterValues: (newParameterValues: Array<AnalyticsParameterValue>) => void
): void {
  const parameterIdToValueJson = objectFromEntries(
    oldParameterValues.map((value) => [value.config.id, value.valueJson])
  );

  let anyValuesChanged = false;
  const newParameterValues = parameterConfigs.reduce((currentParameterValues, config) => {
    const headerIndex = legacyRunQueryOutput.headers.indexOf(config.systemName);
    if (headerIndex !== -1 && parameterIdToValueJson[config.id] !== row[headerIndex]) {
      anyValuesChanged = true;
      return updateValueJsonForConfig(parameterConfigs, currentParameterValues, config.id, row[headerIndex]);
    }
    return currentParameterValues;
  }, oldParameterValues);

  if (anyValuesChanged) {
    updateParameterValues(newParameterValues);
  }
}
